import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectClassicCustomEmbedRoute: InvariantJiraRoute = {
	name: 'issue-navigator-classic-custom-embed',
	path: '/jira/software/c/projects/:projectKey/issues/:navigationItemId/embed',
};
